import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {ReviewThumbnail} from "@COMPONENTS/product/pages/detailPackage/desktop/schedule/Review";
import * as style from "@COMPONENTS/style/detailpackage/reviewpopup";
import {PopupCloseButton} from "@FRAMEWORK/ui/desktop/button";
import useReview, {AttachType} from "@QUERIES/portal/useReview";
import {MouseEvent, useEffect, useMemo} from "react";

type Props = {goodsCd: string; close: () => void; reviewOpen: (reviewId: number, attach: AttachType) => void};

const ReviewListPopupComponent = (props: Props) => {
	const {close, goodsCd, reviewOpen} = props;

	// 리뷰 리스트 조회
	const reviewDataFetch = useReview(goodsCd);
	const reviewData = reviewDataFetch.data?.body || null;

	// 리뷰 데이터 정제
	const originReview = useMemo(() => {
		const {reviewList, attachList: attach} = reviewData;
		return reviewList.reduce((acc, cur) => {
			const attachList = attach.filter(v => v.reviewId === cur.reviewId);
			const item = {...cur, attachList};
			acc.push(item);
			return acc;
		}, []);
	}, [reviewData]);

	/** 사진&동영상 리스트 */
	const galleries = useMemo(() => originReview?.filter(v => v.attachList?.length > 0) ?? [], [originReview]);

	// 스크롤 제거
	useEffect(() => {
		document.body.style.overflowY = "hidden";
		return () => {
			document.body.style.removeProperty("overflow-y");
		};
	}, []);

	// 리뷰 상세 이동
	const handleClick = (e: MouseEvent, reviewId: number) => {
		e.preventDefault();
		close();
		reviewOpen(reviewId, null);
	};

	return (
		<style.Wrap>
			<style.Popup>
				<style.Header line={false}>
					<h3>사진&amp;동영상</h3>
					<PopupCloseButton onClose={close} />
				</style.Header>
				<style.Content>
					<style.Gallery>
						{galleries.map(gallery => {
							const {reviewId, attachList} = gallery;
							return (
								<li key={reviewId}>
									<style.GalleryItem href="#" onClick={e => handleClick(e, reviewId)}>
										{attachList.length > 1 && <span>{attachList.length}</span>}
										<ReviewThumbnail {...attachList[0]} height="122px" width="122px" />
									</style.GalleryItem>
								</li>
							);
						})}
					</style.Gallery>
				</style.Content>
			</style.Popup>
		</style.Wrap>
	);
};

const ReviewListPopup = (props: Props) => (
	<ErrorBoundary>
		<ReviewListPopupComponent {...props} />
	</ErrorBoundary>
);

export default ReviewListPopup;
